import { createAction } from 'redux-actions';

export const HIDED_SIDEBAR = 'HIDED_SIDEBAR';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const HIDING_SIDEBAR = 'HIDING_SIDEBAR';

export const hidedSidebar = createAction(HIDED_SIDEBAR);
export const showSidebar = createAction(SHOW_SIDEBAR);
export const hidingSidebar = createAction(HIDING_SIDEBAR);